import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import footerIcon from "../../assets/Evenflow-logo.png";
import lightIcon from '../../assets/EvenFlow Logo Light.svg'
import { useAppStateContext } from '../../state/AppContextProvider';

const Footer: React.FC = () => {

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        flexDirection: 'row', // Always row
        justifyContent: 'center',
        alignItems: 'center',
        padding: '1px',
        backgroundColor: 'background.paper',
        borderTop: '1px solid #e7e7e7',
        borderColor: 'divider',
        textAlign: 'center', // Optional: center text horizontally
      }}
    >
      <Typography variant="body1" sx={{ marginRight: '16px', fontSize: '10px' }}>
        Powered By 
      </Typography>
      <Box
        component="img"
        src={sessionStorage.getItem("themeMode") === 'dark' ? lightIcon : footerIcon}
        alt="Footer Image"
        title="Evenflow"
        sx={{
          width: '90px',
          height: '35px',
          marginTop: { xs: 0, sm: 0 }, // No margin on mobile
          color: 'primary.main',
        }}
      />
    </Box>
  );
};

export default Footer;
